{
  "name": "cortito",
  "version": "2.8.0",
  "private": true,
  "license": "MIT",
  "packageManager": "npm@11.19.0",
  "engines": {
    "node": ">=26.0.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "node scripts/start.mjs",
    "start:app": "ng serve",
    "functions:serve": "npm --prefix functions run build && firebase emulators:start --only functions --project corti-to",
    "build": "ng build",
    "build-dev": "ng build --configuration dev",
    "build-prod": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "playwright test",
    "format": "prettier --write \"src/**/*.{ts,html,css}\" \"e2e/*.ts\"",
    "deploy-dev": "npm run build-dev && firebase deploy --only hosting:dev --project corti-to"
  },
  "dependencies": {
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@tailwindcss/postcss": "^4.3.3",
    "daisyui": "^5.7.16",
    "firebase": "^12.17.1",
    "qrcode-generator": "^2.0.4",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.3.3",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.3",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.0",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.62.1",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.8.1",
    "firebase-tools": "^15.28.1",
    "jsdom": "^28.0.0",
    "prettier": "^3.8.1",
    "typescript": "~6.0.2",
    "typescript-eslint": "^8.66.0",
    "vitest": "^4.0.8"
  }
}
